/**
 * S01 v3 · «вердикт-проба» — inline «кто это делает?» drill (T00/MS-01 synthesis mockup).
 *
 * Each `.q3-row[data-a]` holds a statement (`.st`), 2-3 answer buttons `button[data-v]`,
 * and a hidden verdict (`.vd`). First click: mark the row `.done`, tag the chosen button
 * `.ok`/`.no`, and reveal the verdict — `data-vd` (explanation of the correct answer),
 * led by a correct/incorrect prefix. Answer-once (later clicks are inert).
 *
 * Ephemeral (no persistence) · StrictMode-safe (init-guard + cleanup).
 */
export function initVerdictProbe(root: HTMLElement): () => void {
  const rows = Array.from(root.querySelectorAll<HTMLElement>('.q3-row'));
  const cleanups: Array<() => void> = [];

  for (const row of rows) {
    if (row.dataset.vpInit === '1') continue;
    row.dataset.vpInit = '1';
    const vd = row.querySelector<HTMLElement>('.vd');

    const onClick = (e: MouseEvent) => {
      const btn = (e.target as HTMLElement).closest<HTMLButtonElement>('button[data-v]');
      if (!btn || !row.contains(btn)) return;
      if (row.classList.contains('done')) return; // answer-once

      const correct = btn.dataset.v === row.dataset.a;
      row.classList.add('done');
      btn.classList.add(correct ? 'ok' : 'no');
      row.setAttribute('aria-live', 'polite');
      if (vd) vd.textContent = (correct ? 'Точно. ' : 'Не совсем: ') + (row.dataset.vd ?? '');
    };

    row.addEventListener('click', onClick);
    cleanups.push(() => {
      row.removeEventListener('click', onClick);
      delete row.dataset.vpInit;
    });
  }

  return () => cleanups.forEach((fn) => fn());
}
